var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreadcrumbShape05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 300,
    viewBox: "0 0 514 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.136 -76.9198C167.83 -104.934 124.043 -106.726 89.1605 -99.9C39.1124 -90.0984 -0.809205 -61.6968 1.8063 -4.5089C2.30766 6.3196 4.63877 18.7735 13.2117 31.933C26.5901 52.4636 50.4695 67.9875 71.2674 78.6771C123.08 105.321 171.998 117.949 218.833 127.767C262.455 136.916 305.085 143.963 346.723 148.909C379.223 152.796 411.644 155.266 435.844 146.571C439.302 145.32 442.777 143.436 441.939 138.732C441.251 135.636 439.274 132.091 436.419 128.831C424.811 115.07 408.129 110.079 395.792 108.784C333.753 102.463 295.636 133.532 273.662 175.363C266.616 188.807 261.059 204.975 269.927 227.356C281.81 257.422 317.191 289.464 348.621 305.393C380.05 321.323 408.155 324.507 434.243 325.884C500.022 329.28 560.135 323.23 613.287 307.864",
    stroke: "#BBB0DB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbShape05);
export default __webpack_public_path__ + "static/media/breadcrumb_shape05.00c0bda3b3e7478f6a540afb2a891699.svg";
export { ForwardRef as ReactComponent };